<template>
	<div class="c-editor-addablechart-modal">
		<v-modal v-if="addchart" @cancel="$store.commit('END_ADDCHART');">
			<div v-cloak slot="title">Slide hinzufügen</div>
			<div v-cloak slot="message">
				<div class="row" v-for="chs in chunk(addAbleChartsByChart(addchart), 4)">
					<div class="col-xs-12 col-sm-3" v-for="ch in chs">
						<button @click="addChartToPresentation(ch)" class="no-btn v-chart-preview st-chart-preview">
							<div v-if="ch.title">
								<strong>{{ $t(ch.title) }}</strong>
							</div>
							<div class="st-chart-preview__img" :style="(ch.image ? 'background-image: url(' + ch.image + ')' : '')">
								<div class="st-chart-preview__wrap">
									<div class="st-chart-preview__alttext" v-if="!ch.image">
										<strong v-if="ch.fields && ch.fields.title">{{ ch.fields.title.value }}</strong>
										<strong v-else>{{ ch.template }}</strong>
									</div>
								</div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</v-modal>
	</div>
</template>
<script>

import chunk from 'lodash/chunk';

import help_chart from '@/helpers/chart';
import help_rest from '@/helpers/rest';

export default {
	name: 'c-editor-addablechart-modal',
	computed: {
		addchart(){
			return this.$store.getters.addchart;
		},
	},
	methods: {
		chunk: chunk,
		...help_rest,
		...help_chart,
		addAbleChartsByChart(chartid){
			if(chartid){
				let chart = this.$store.getters.getChartById(chartid);
				if(chart && chart.addablecharts) {
					return chart.addablecharts;
				}
			}

			return this.$store.getters.presentation.addablecharts;
		},
		addChartToPresentation(chart){
			const self = this,
				  url = this.$store.getters.presentation.urls.newchart.replace(':charttemplate:', chart.template);


			this.restoptions(url, 'NEW_CHART')
			.then(function(rawchart){
				if(typeof rawchart.id !== 'number') {
					self.$store.commit('INCREASE_NEWCHARTCOUNTER')
					rawchart.id = self.$store.getters.newchartcounter;
				}

				rawchart.title = self.$t(rawchart.title);
				if(rawchart.fields && rawchart.fields.title){
					rawchart.fields.title.value = self.$t(rawchart.title);
					rawchart.fields.title.chanegd = true;
				}

				self.setupChart(rawchart);
				// self.$store.commit('ADD_CHART', rawchart);
				self.$store.dispatch('ADD_CHART', rawchart)
				.then(chart => {
					if(self.$route.params.chartid != chart.id){
						self.$router.push({ params: { chartid: chart.id }});
					}

					self.$store.commit('END_ADDCHART');
				});

			});
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/p-editor/c-editor-addablechart-modal.vue